import { Link } from "react-router-dom";
import { formatDate, initials } from "../lib/api";

export default function PostCard({ post, index = 0 }) {
  return (
    <Link
      to={`/entrada/${post.slug}`}
      className={`post-card reveal d${(index % 6) + 1}`}
      data-testid={`post-card-${post.slug}`}
    >
      <div className="post-img">
        <img src={post.imagen_url} alt={post.alt_text || post.titulo} loading="lazy" />
        <div className="post-img-top">
          <span className="tag tag-accent">{post.categoria}</span>
          <span className="post-views">
            {(post.vistas || 0).toLocaleString("es-ES")} lecturas
          </span>
        </div>
      </div>
      <h3 className="post-title">{post.titulo}</h3>
      <p className="post-excerpt">{post.excerpt}</p>
      <div className="post-meta">
        <span className="post-author">
          <span className="post-author-avatar" data-testid={`post-avatar-${post.slug}`}>
            {initials(post.autor)}
          </span>
          {post.autor}
        </span>
        <span>
          {formatDate(post.fecha_publicacion)} · {post.tiempo_lectura} min
        </span>
      </div>
    </Link>
  );
}
